<template>
  <div class="vRContent">
    <iframe :src="vrSrc" width="100%" height="100%"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      vrSrc: '',
    };
  },
  computed: {},
  mounted() {
    this.vrSrc = 'https://www.720yun.com/t/b6vkOmfyO2y#scene_id=56970256';
  },
  methods: {},
};
</script>

<style scoped lang="less">
.vRContent {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
}
</style>
